import React from "react";
import PropTypes from "prop-types";
import Image from "@/bit/components/components.c-image";
import TextInfo from "@/bit/components/components.text";

const CmsImageText = (props) => {
  const {
    layout,
    cmsHandler = null,
    blockName,
    alias,
    index,
    frontalListToDelete,
    CmsEditableGroupIcons,
    blockImageAspectRatio,
  } = props;

  return (
    <>
      <div
        className={`cms-image-text wrapper-information ${
          layout === "row-reversed" ? "reverse" : ""
        } ${blockImageAspectRatio ? "has-aspect-ratio" : ""}`}
      >
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            noCustomLink
            elementProps={{
              ...props,
              editName: "cms-block.cms-image-text",
            }}
            deleteProps={{
              index,
              itemIdDotNotation: `${blockName}.cms-ml-image-text-list-1`,
              alias,
              frontalListToDelete,
            }}
            visibleTools={{
              hiring: false,
              edit: true,
              deleteItem: true,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        <div className="wrapper-text">
          {props["cms-atom-text-1"] && (
            <TextInfo {...props["cms-atom-text-1"]} cmsHandler={cmsHandler} />
          )}
        </div>

        {blockImageAspectRatio ? (
          <div className="wrapper-image-outer">
            <div className="wrapper-image">
              <Image
                {...props["cms-atom-image-1"]}
                objectFit="cover"
                fill={false}
                height={500}
                width={600}
                cyData="CmsImageText Image-1"
                cmsHandler={cmsHandler}
              />
            </div>
          </div>
        ) : (
          <div className="wrapper-image">
            <Image
              {...props["cms-atom-image-1"]}
              objectFit="cover"
              cyData="CmsImageText Image-1"
              cmsHandler={cmsHandler}
            />
          </div>
        )}
      </div>
      <style jsx>{`.wrapper-information {
  display: flex;
  gap: 32px;
  align-items: stretch;
  margin-bottom: 48px;
  position: relative;

  .wrapper-text {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .wrapper-image {
    position: relative;
    width: 38%;
    min-height: 250px;
    overflow: hidden;
    border-radius: 20px;
  }

  &.has-aspect-ratio {
    .wrapper-image-outer {
      display: flex;
      align-items: center;
      justify-content: center;
      .wrapper-image {
        width: 100%;
        :global(.img) {
          border-radius: 16px !important;
          width: 100%;
        }
      }
    }
  }

  &.reverse {
    flex-direction: row-reverse;
  }

  /* Tablet y móvil */
  @media (max-width: 1024px) {
    flex-direction: column;
    &.reverse {
      flex-direction: column;
    }
    .wrapper-text {
      width: 100%;
      order: 2;
    }

    .wrapper-image {
      order: 1;
      width: 100%;
      flex: none;
      min-height: 320px;
    }

    &.has-aspect-ratio {
      .wrapper-image-outer {
        height: auto;
        width: auto;
        .wrapper-image {
          height: auto;
          width: auto;
          :global(.img) {
            border-radius: 16px !important;
            height: auto;
            width: 100% !important;
          }
        }
      }
    }
  }

  /* Solo móvil: reescala la imagen para que no se desborde */
  @media (max-width: 632px) {
    .wrapper-image {
      :global(img) {
        width: 100%;
        height: auto;
      }
    }

    &.has-aspect-ratio {
      .wrapper-image-outer {
        width: 100%;
        .wrapper-image {
          width: 100%;
          min-height: 0;
          :global(img) {
            border-radius: 16px !important;
            width: 100% !important;
            height: auto;
          }
        }
      }
    }
  }
}
`}</style>
    </>
  );
};

CmsImageText.propTypes = {
  /**
   * {
   *  "info": "Define cómo se posiciona la imgen y el texto y puede ser uno de los siguientes valores: 'row', 'row-reversed'.",
   *  "kind": "both",
   *  "beautifulName": "Layout",
   *  "values": "./enums.js:LAYOUT"
   * }
   */
  layout: PropTypes.string,
  /**
   * {
   *  "info": "La imagen no se redimensiona sino que se mantiene estatica según en ancho",
   *  "kind": "both",
   *  "beautifulName": "Bloquear tamaño de imagen"
   * }
   */
  blockImageAspectRatio: PropTypes.bool,
};

CmsImageText.defaultProps = {
  layout: "",
  blockImageAspectRatio: false,
};

export default CmsImageText;
